export default "__VITE_ASSET__19cbd45d__"